import { render, staticRenderFns } from "./LandingCanvas.vue?vue&type=template&id=806d30d2&"
import script from "./LandingCanvas.vue?vue&type=script&lang=js&"
export * from "./LandingCanvas.vue?vue&type=script&lang=js&"
import style0 from "./LandingCanvas.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports